"use client"

import { usePathname, useRouter, useSearchParams } from "next/navigation"
import { useState } from "react"

const SearchInResults = ({ listName }: { listName?: string }) => {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const [q, setQ] = useState(searchParams.get("q") ?? "")
  const placeholder = listName ? `Search in ${listName}` : "Search products"

  return (
    <form
      role="search"
      className="relative text-sm"
      onSubmit={(e) => {
        e.preventDefault()
        const params = new URLSearchParams(searchParams)
        q.trim() ? params.set("q", q.trim()) : params.delete("q")
        params.delete("page")
        router.push(`${pathname}?${params.toString()}`)
      }}
    >
      <label htmlFor="results-search" className="sr-only">{placeholder}</label>
      <input
        id="results-search"
        type="search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder={placeholder}
        className="w-full p-2 pr-9 rounded-lg border border-transparent focus:border-elevate-black focus:outline-none"
      />
      <button type="submit" aria-label="Search" className="absolute inset-y-0 right-0 flex items-center pr-3">
        <svg aria-hidden width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>
      </button>
    </form>
  )
}

export default SearchInResults
